/* First-run language gate — the desktop's LanguageSelectScreen in the Brightivity kit. Shown once per browser,
 * before sign-in, whenever no language has been chosen (i18n rule 9: works before any sign-in). Option labels stay
 * in their own language; the title and Continue re-render in whichever language is highlighted. */
import { useState } from 'react';
import i18n, { LANGUAGES, osLanguageGuess, setLanguage } from '../i18n/index.js';
import { Button, Card } from '../ui/index.jsx';
import '../app/shell.css';
import '../features/auth/auth.css';
import './LanguageSelectScreen.css';

export default function LanguageSelectScreen({ onDone }) {
  const [selected, setSelected] = useState(osLanguageGuess());
  const [saving, setSaving] = useState(false);
  const fixedT = i18n.getFixedT(selected, 'common');
  const go = async () => {
    if (saving) return;
    setSaving(true);
    try { await setLanguage(selected); onDone(); } finally { setSaving(false); }
  };
  return (
    <div className="bv-signin" data-testid="language-gate">
      <Card className="bv-signin__card" pad={false}>
        <img className="bv-signin__logo" src="/brand/logo-long-on-light.svg" alt="Brightivity" />
        <h1 className="bv-signin__title">{fixedT('language.title')}</h1>
        <p className="bv-signin__sub">{fixedT('language.subtitle')}</p>
        <div className="bv-langpick" role="radiogroup" aria-label={fixedT('language.title')}>
          {LANGUAGES.map((lang) => (
            <button key={lang.code} type="button" role="radio" aria-checked={selected === lang.code} lang={lang.code}
              className={`bv-langpick__opt${selected === lang.code ? ' is-on' : ''}`} data-testid={`lang-${lang.code}`}
              onClick={() => setSelected(lang.code)} onDoubleClick={go}>
              <span className="bv-langpick__native">{lang.label}</span>
              {lang.code !== 'en' && <span className="bv-langpick__english">{lang.englishName}</span>}
            </button>
          ))}
        </div>
        <Button variant="coral" block style={{ height: 52 }} onClick={go} disabled={saving} data-testid="lang-continue">{fixedT('actions.continue')}</Button>
      </Card>
    </div>
  );
}
